/**
 * Переключатель режимов ассистента (US-10 FR-2.1): ряд пиктограмм-пилюль,
 * активная выделена фирменным зелёным. Состав ряда зависит от роли —
 * «Загрузка» не показывается без права ввода (FR-2.3).
 */
import { useTranslation } from 'react-i18next';

import type { AssistantModeDef } from './modes';
import { cn } from '../../lib/cn';
import type { AssistantMode } from '../../types/assistant';

interface ModeSwitcherProps {
  modes: readonly AssistantModeDef[];
  active: AssistantMode;
  onSelect: (mode: AssistantMode) => void;
}

export const ModeSwitcher = ({ modes, active, onSelect }: ModeSwitcherProps) => {
  const { t } = useTranslation();
  return (
    <div
      className="flex shrink-0 gap-2 overflow-x-auto border-b border-surface-border bg-surface px-4 py-3"
      role="tablist"
      aria-label={t('assistant.modesAria')}
      data-testid="assistant-modes"
    >
      {modes.map((mode) => {
        const Icon = mode.icon;
        const selected = mode.id === active;
        return (
          <button
            key={mode.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onSelect(mode.id)}
            data-testid={`assistant-mode-${mode.id}`}
            className={cn(
              'flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-2 text-xs font-semibold transition-colors',
              selected
                ? 'border-brand-500 bg-brand-500 text-text-inverted'
                : 'border-surface-border bg-surface text-text hover:border-brand-100 hover:bg-brand-50',
            )}
          >
            <Icon className="size-3.5" aria-hidden="true" />
            {t(`assistant.modes.${mode.id}.label`)}
          </button>
        );
      })}
    </div>
  );
};
